// extracted by mini-css-extract-plugin
export default {"bottomBar":"BottomBar_bottomBar__ctT67","active":"BottomBar_active__kg0Yp"};